import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { FieldValueType, } from '../Fields';
import BuiltInFieldLabel from './BuiltInFieldLabel/BuiltInFieldLabel';
import EmailInput from './FieldInputs/EmailInput/EmailInput';
import NameInput from './FieldInputs/NameInput/NameInput';
import PhoneInput from './FieldInputs/PhoneInput/PhoneInput';
import AddressInput from './FieldInputs/AddressInput/AddressInput';
import AssigneeInput from './FieldInputs/AssigneeInput/AssigneeInput';
import LabelsSelector from '../../LabelsSelector/LabelsSelector';
import { CommonInput } from './FieldInputs/CommonInput/CommonInput';
import FieldActionsMenu from '../FieldActionsMenu/FieldActionsMenu';
import { Box, Cell, Layout } from 'wix-style-react';
import { DateInput } from '../DateInput/DateInput';
export var builtInFieldDataHook = function (field) {
    return "builtInField-" + field.id + (field.index || 0);
};
var BuiltInField = /** @class */ (function (_super) {
    __extends(BuiltInField, _super);
    function BuiltInField(props) {
        return _super.call(this, props) || this;
    }
    BuiltInField.prototype.getErrorForField = function () {
        var _a = this.props, field = _a.field, errorField = _a.errorField, validationError = _a.validationError;
        if (errorField && validationError && field.id === errorField.id) {
            var isFieldInList = 'index' in field;
            if (isFieldInList) {
                if (field.index === errorField.index) {
                    return validationError;
                }
            }
            else {
                return validationError;
            }
        }
        return null;
    };
    BuiltInField.prototype.renderBuiltInField = function (fieldType) {
        var _a;
        var _this = this;
        var field = this.props.field;
        var fieldKey = field.id + "-" + (field.index || 0);
        var builtInFields = (_a = {},
            _a[FieldValueType.NAME] = (React.createElement(NameInput, { key: fieldKey, value: field.value, onValueChange: this.props.onFieldValueChange })),
            _a[FieldValueType.EMAIL] = (React.createElement(EmailInput, { key: fieldKey, value: field.value, onValueChange: this.props.onFieldValueChange, errorType: this.getErrorForField(), onCheckForDuplicateEmail: this.props.onCheckForDuplicateEmail })),
            _a[FieldValueType.PHONE] = (React.createElement(PhoneInput, { key: fieldKey, value: field.value, onValueChange: this.props.onFieldValueChange })),
            _a[FieldValueType.ADDRESS] = (React.createElement(AddressInput, { key: fieldKey, countries: this.props.countries, value: field.value, onValueChange: this.props.onFieldValueChange })),
            _a[FieldValueType.ASSIGNEES] = (React.createElement(AssigneeInput, { key: 'AssigneeInput', contactId: this.props.contactId, assigneeId: field.value, onValueChange: this.props.onFieldValueChange, component: this.props.assigneeComponent, log: this.props.log })),
            _a[FieldValueType.LABELS] = (React.createElement(Layout, { gap: 0, key: fieldKey },
                React.createElement(Cell, { span: 12 },
                    React.createElement(LabelsSelector, { labels: this.props.labels, selectedLabels: this.props.field.value.labels, newLabels: this.props.field.value.newLabels, onChange: this.props.onFieldValueChange, log: this.props.log })))),
            _a[FieldValueType.WEBSITE] = (React.createElement(CommonInput, { key: fieldKey, dataHook: "website-input", value: field.value.url, placeholder: this.props.t('editContact.field.website.placeholder'), onChange: function (url) { return _this.props.onFieldValueChange({ url: url }); } })),
            _a[FieldValueType.VAT_ID] = (React.createElement(CommonInput, { key: fieldKey, dataHook: "vat-id-input", value: field.value, placeholder: this.props.t('editContact.field.vatId.placeholder'), onChange: this.props.onFieldValueChange })),
            _a[FieldValueType.COMPANY] = (React.createElement(CommonInput, { key: fieldKey, dataHook: "company-name-input", value: field.value, placeholder: this.props.t('editContact.field.company.name.placeholder'), onChange: this.props.onFieldValueChange })),
            _a[FieldValueType.POSITION] = (React.createElement(CommonInput, { key: fieldKey, dataHook: "company-position-input", value: field.value, placeholder: this.props.t('editContact.field.company.role.placeholder'), onChange: this.props.onFieldValueChange })),
            _a[FieldValueType.DATE] = (React.createElement(DateInput, { key: fieldKey, dataHook: "built-in-date-input-" + field.index, value: field.value.date, placeholder: this.props.t('editContact.field.dates.placeholder'), onChange: function (date) {
                    _this.props.onFieldValueChange({
                        date: date,
                    });
                }, lng: this.props.lng || 'en' })),
            _a[FieldValueType.BIRTHDAY] = (React.createElement(DateInput, { key: fieldKey, dataHook: "built-in-birthday-input", value: field.value, placeholder: this.props.t('editContact.field.birthday.placeholder'), onChange: this.props.onFieldValueChange, lng: this.props.lng || 'en' })),
            _a);
        return builtInFields[fieldType];
    };
    BuiltInField.prototype.render = function () {
        var _a = this.props, field = _a.field, onFieldTagChange = _a.onFieldTagChange, actions = _a.actions, required = _a.required;
        var fieldIndex = field.index || 0;
        return (React.createElement(Layout, { gap: 10, dataHook: builtInFieldDataHook(field) },
            React.createElement(Cell, { span: 2 },
                React.createElement(BuiltInFieldLabel, { field: field, onFieldTagChange: onFieldTagChange, required: required })),
            React.createElement(Cell, { span: 9 }, this.renderBuiltInField(field.type)),
            React.createElement(Cell, { span: 1 },
                React.createElement(Box, { align: "right", marginLeft: "47px", marginTop: "3px" },
                    React.createElement(FieldActionsMenu, { actions: actions, dataHook: field.id + "-" + fieldIndex, onActionClicked: this.props.onFieldActionClick })))));
    };
    return BuiltInField;
}(React.PureComponent));
export default translate()(BuiltInField);
//# sourceMappingURL=BuiltInField.js.map